// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingCta_band__HhJQR {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ecf4fa;
  padding: 36px 20px;
}

.BookingCta_button__dhKUG {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
  background-color: #0072bb;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-decoration: none;
  padding: 16px 42px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 114, 187, 0.35);
  transition: background-color 0.2s ease, transform 0.15s ease;
}

.BookingCta_button__dhKUG:hover {
  background-color: #005f9e;
  transform: translateY(-1px);
}

.BookingCta_button__dhKUG:focus-visible {
  outline: 3px solid #7ecbff;
  outline-offset: 3px;
}

@media (max-width: 767px) {
  .BookingCta_band__HhJQR {
    padding: 20px 16px;
  }

  .BookingCta_button__dhKUG {
    width: 100%;
    font-size: 18px;
    padding: 16px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Sections/BookingCta.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".band {\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ecf4fa;\n  padding: 36px 20px;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-sizing: border-box;\n  background-color: #0072bb;\n  color: #fff;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n  padding: 16px 42px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 114, 187, 0.35);\n  transition: background-color 0.2s ease, transform 0.15s ease;\n}\n\n.button:hover {\n  background-color: #005f9e;\n  transform: translateY(-1px);\n}\n\n.button:focus-visible {\n  outline: 3px solid #7ecbff;\n  outline-offset: 3px;\n}\n\n@media (max-width: 767px) {\n  .band {\n    padding: 20px 16px;\n  }\n\n  .button {\n    width: 100%;\n    font-size: 18px;\n    padding: 16px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"band": `BookingCta_band__HhJQR`,
	"button": `BookingCta_button__dhKUG`
};
export default ___CSS_LOADER_EXPORT___;
